export default __webpack_public_path__ + "static/media/about-photo-2.1bc3cc50.jpg";